export function deleteCookie(name) {
    setCookie(name, '', -1e6)
}

export function deleteAllCookies() {
    const cookies = getCookies()
    Object.keys(cookies).forEach(deleteCookie)
}

export function getCookie(name) {
    const cookies = document.cookie.split(';')
    const key = name + '='

    for (let cookie of cookies) {
        cookie = cookie.trim()

        if (cookie.startsWith(key)) {
            return cookie.substring(key.length, cookie.length)
        }
    }

    return null
}

export function getCookies() {
    const obj = {}
    const cookies = document.cookie.split(';')

    for (const cookie of cookies) {
        const [key, value] = cookie.split('=')
        obj[key.trim()] = value
    }

    return obj
}

export function setCookie(name, value, days, path = '/') {
    const now = new Date()
    now.setTime(now.getTime() + (days * 24 * 60 * 60 * 1000))
    const expires = `expires=${now.toUTCString()}`
    document.cookie = name + '=' + value + '; ' + expires + '; path=' + path
}

window.cookies = {
    deleteAllCookies
}
